import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsUserRelationshipCacheKey, customObjectsLinkedToUserCacheKey } from "./constants";
import type { PatchCustomObjectsUserRelationshipParams } from "./types";

export const patchCustomObjectsUserRelationship = reactQueryMutationAdapter(
  [customObjectsUserRelationshipCacheKey, customObjectsLinkedToUserCacheKey],
  ({ typeName, objectId, userId, relId, attributes }: PatchCustomObjectsUserRelationshipParams): Promise<void> => {
    return fetch(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(objectId)}/users/${encodeURIComponent(userId)}`,
      "PATCH",
      { rel_id: relId, attributes },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
